import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import React from 'react'

import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'
import { getScorecardConfigVersionOptions } from '@/reducers/qa-copilot/qa-copilot.helpers'

export const QACopilotScorecardVersionSelector = () => {
  const history = useHistory()
  const { scorecardConfig, scorecardConfigVersions, loading } = useSelector(
    (state) => state.qaCopilot
  )

  const handleSelectScorecardVersion = (value) => {
    history.push(`/qa-copilot/${value}`)
  }

  return (
    <div data-testid="scorecard-version-selector" className="scorecard-version-selector">
      <FormField>
        <Select
          options={getScorecardConfigVersionOptions(scorecardConfigVersions)}
          value={scorecardConfig ? scorecardConfig.id : null}
          isClearable={false}
          onChange={({ value }) => {
            handleSelectScorecardVersion(value)
          }}
          loading={loading.scorecardConfigVersions}
          fixedWidth
        />
      </FormField>
    </div>
  )
}
